!function (e) {
  function s(e, s) {
    for (var a = 0; a < s; a++) {
      e = e.replace(/<self>/g, function () {
        return "(?:" + e + ")";
      });
    }
    return e.replace(/<self>/g, "[^\\s\\S]").replace(/<str>/g, '(?:@(?!")|"(?:[^\r\n\\\\"]|\\\\.)*"|@"(?:[^\\\\"]|""|\\\\[^])*"(?!")|\'(?:(?:[^\r\n\'\\\\]|\\\\.|\\\\[Uux][\\da-fA-F]{1,8})\'|(?=[^\\\\](?!\'))))').replace(/<comment>/g, "(?:/(?![/*])|//.*[\r\n]|/\\*[^*]*(?:\\*(?!/)[^*]*)*\\*/)");
  }
  var a = s("\\((?:[^()'\"@/]|<str>|<comment>|<self>)*\\)", 2),
    t = s("\\[(?:[^\\[\\]'\"@/]|<str>|<comment>|<self>)*\\]", 1),
    r = s("\\{(?:[^{}'\"@/]|<str>|<comment>|<self>)*\\}", 2),
    n = "@(?:await\\b\\s*)?(?:(?!await\\b)\\w+\\b|" + a + ")(?:[?!]?\\.\\w+\\b|(?:" + s("<(?:[^<>'\"@/]|<comment>|<self>)*>", 1) + ")?" + a + "|" + t + ")*(?![?!\\.(\\[]|<(?!/))",
    l = "(?:\"[^\"@]*\"|'[^'@]*'|[^\\s'\"@>=]+(?=[\\s>])|[\"'][^\"'@]*(?:(?:@(?![\\w()])|" + n + ")[^\"'@]*)+[\"'])",
    i = "(?:\\s(?:\\s*[^\\s>/=]+(?:\\s*=\\s*<tagAttrValue>|(?=[\\s/>])))+)?".replace(/<tagAttrValue>/, l),
    g = "(?!\\d)[^\\s>/=$<%]+" + i + "\\s*/?>",
    o = "\\B@?(?:<([a-zA-Z][\\w:]*)" + i + "\\s*>(?:[^<]|</?(?!\\1\\b)" + g + "|" + s("<\\1" + i + "\\s*>(?:[^<]|</?(?!\\1\\b)" + g + "|<self>)*</\\1\\s*>", 2) + ")*</\\1\\s*>|<" + g + ")";
  e.languages.cshtml = e.languages.extend("markup", {});
  var c = {
      pattern: /\S[\s\S]*/,
      alias: "language-csharp",
      inside: e.languages.insertBefore("csharp", "string", {
        html: {
          pattern: RegExp(o),
          greedy: !0,
          inside: e.languages.cshtml
        }
      }, {
        csharp: e.languages.extend("csharp", {})
      })
    },
    p = {
      pattern: RegExp("(^|[^@])" + n),
      lookbehind: !0,
      greedy: !0,
      alias: "variable",
      inside: {
        keyword: /^@/,
        csharp: c
      }
    };
  e.languages.cshtml.tag.pattern = RegExp("</?" + g), e.languages.cshtml.tag.inside["attr-value"].pattern = RegExp("=\\s*" + l), e.languages.insertBefore("inside", "punctuation", {
    value: p
  }, e.languages.cshtml.tag.inside["attr-value"]), e.languages.insertBefore("cshtml", "prolog", {
    "razor-comment": {
      pattern: /@\*[\s\S]*?\*@/,
      greedy: !0,
      alias: "comment"
    },
    block: {
      pattern: RegExp("(^|[^@])@(?:" + [r, "(?:code|functions)\\s*" + r, "(?:for|foreach|lock|switch|using|while)\\s*" + a + "\\s*" + r, "do\\s*" + r + "\\s*while\\s*" + a + "(?:\\s*;)?", "try\\s*" + r + "\\s*catch\\s*" + a + "\\s*" + r + "\\s*finally\\s*" + r, "if\\s*" + a + "\\s*" + r + "(?:\\s*else(?:\\s+if\\s*" + a + ")?\\s*" + r + ")*", "helper\\s+\\w+\\s*" + a + "\\s*" + r].join("|") + ")"),
      lookbehind: !0,
      greedy: !0,
      inside: {
        keyword: /^@\w*/,
        csharp: c
      }
    },
    directive: {
      pattern: /^([ \t]*)@(?:addTagHelper|attribute|implements|inherits|inject|layout|model|namespace|page|preservewhitespace|removeTagHelper|section|tagHelperPrefix|using)(?=\s).*/m,
      lookbehind: !0,
      greedy: !0,
      inside: {
        keyword: /^@\w+/,
        csharp: c
      }
    },
    value: p,
    "delegate-operator": {
      pattern: /(^|[^@])@(?=<)/,
      lookbehind: !0,
      alias: "operator"
    }
  }), e.languages.razor = e.languages.cshtml;
}(Prism);